import { Distance } from "@ptx-autonomous/libs/units";

export function convertMetersToFeet(value?: number) {
	return Math.round(1000 * new Distance(value ?? 0, "m").ft()) / 1000;
}

export function convertMetersToInches(value?: number) {
	return Math.round(1000 * new Distance(value ?? 0, "m").in()) / 1000;
}

export function feetAndInchesToMeters(feet: number, inches: number) {
	const totalInches = feet * 12 + inches;
	return new Distance(totalInches, "in").m();
}
